import BundlePackageGroupMobile from "./mobile/BundlePackageGroupMobile";
import styles from "./BundlePackageGroup.module.css";
import { BundlePackageData } from "../../interfaces/bundlePackageGroup/BundlePackageGroup.type";
import { styleHelper } from "../../helpers/commonFunctions";
import useAppStore from "../../store/AppStore";

export default function BundlePackageGroupContainer({
  items,
  scroll
}: {
  items: BundlePackageData[];
  scroll?: boolean;
}) {
  return (
    <>
      {scroll ? (
          <div
              className={`vas-d-flex vas-px-3 vas-gap-3 vas-w-100 ${styles.card_holder}`}
              style={styleHelper({border: "0px"})}
          >
            {items &&
                items.length > 0 &&
                items.map((item, idx) => <BundlePackageGroupMobile data={item} key={idx}/>)}
          </div>
      ) : (
          <div
              className={`vas-d-flex vas-flex-column vas-gap-3 vas-px-3 ${styles.card_holder}`}
              style={styleHelper({border: "0px"})}
          >
            {items &&
                items.length > 0 &&
                items.map((item, idx) => <BundlePackageGroupMobile data={item} key={idx}/>)}
          </div>
      )}
    </>
  );
}
